import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import {
  PAYSDK_EVENTS,
  PAYSDK_TYPES,
  PAYSDK_CONTAINER_ID_PREFIXES,
  PAYSDK_EVENT_METADATA_KEYS,
} from 'constants/paysdk-constants';
import { usePaySdk } from './use-paysdk';
import PaySdkStatusView from './pay-sdk-status-view';
import styles from './pay-sdk-payment-list.less';

const PaySdkPaymentList = ({
  onSelectPayment,
  selectedPaymentTypeID,
  deliveries,
  location,
  countryCode,
  enterprise,
  stateScope,
}) => {
  const handleEvent = useCallback(
    event => {
      if (event && event.event === PAYSDK_EVENTS.PAYMENT_METHOD_SELECTED) {
        const paymentTypeId = _get(
          event,
          PAYSDK_EVENT_METADATA_KEYS.PAYMENT_TYPE_ID,
          '',
        );
        if (paymentTypeId) {
          const paymentMethodType = _get(
            event,
            PAYSDK_EVENT_METADATA_KEYS.PAYMENT_METHOD_TYPE,
            '',
          );
          const shortTitle = _get(
            event,
            PAYSDK_EVENT_METADATA_KEYS.SHORT_TITLE,
            '',
          );
          onSelectPayment({ paymentTypeId, paymentMethodType, shortTitle });
        }
      }
    },
    [onSelectPayment],
  );

  const { containerRef, containerId, scriptLoaded, loadError } = usePaySdk({
    paySdkType: PAYSDK_TYPES.PAYMENT_LIST,
    location,
    deliveries,
    countryCode,
    enterprise,
    selectedPaymentTypeID,
    containerIdPrefix: PAYSDK_CONTAINER_ID_PREFIXES.PAYMENT_LIST,
    onEvent: handleEvent,
    stateScope,
  });

  return (
    <PaySdkStatusView
      loadError={loadError}
      scriptLoaded={scriptLoaded}
      errorFallbackKey="v2.homepage.manualOrder.failedToLoadPaymentOptions"
    >
      <div id={containerId} ref={containerRef} className={styles.container} />
    </PaySdkStatusView>
  );
};

PaySdkPaymentList.propTypes = {
  onSelectPayment: PropTypes.func.isRequired,
  selectedPaymentTypeID: PropTypes.string,
  deliveries: PropTypes.arrayOf(PropTypes.shape({})),
  location: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  countryCode: PropTypes.string,
  enterprise: PropTypes.shape({
    groupID: PropTypes.string,
    profileType: PropTypes.string,
  }),
  stateScope: PropTypes.string,
};

PaySdkPaymentList.defaultProps = {
  selectedPaymentTypeID: '',
  deliveries: [],
  location: {},
  countryCode: '',
  enterprise: {},
  stateScope: undefined,
};

export default PaySdkPaymentList;
